export default __webpack_public_path__ + "static/media/portrait-left.99f78fc7.svg";